import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTheme } from "@mui/material/styles";
import HappySignalOverview from './HappySignalOverview';
import HappySignalBySector from './HappySignalBySector';
import HappySignalByTechnology from './HappySignalByTechnology';
import HappySignalByTrend from './HappySignalByTrend';
import PageWrapper from 'components/Common/PageWraper';

const HappySignals = () => {
    const theme = useTheme();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };

    return (
        <PageWrapper>
            {/* Tab Navigation */}
            <Box
                // px={{ xs: 1, md: 2, lg: 2 }}
                sx={{
                    position: 'sticky',
                    top: '76px',
                    zIndex: 199,
                    backgroundColor: 'backgroundLight.primary',
                    height: '40px'
                }}
            >
                <Stack direction="row" spacing={2}>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'inline-block',
                                color: activeTab === 0 ? 'text.focus' : 'textLight.dark',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleTabClick(0)}
                        >
                            <Typography
                                variant="tabLabel"
                                sx={{ borderBottom: activeTab === 0 ? `4px solid ${theme.palette.text.focus}` : 'none' }}
                            >
                                Happy Signals Overview
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'inline-block',
                                color: activeTab === 1 ? 'text.focus' : 'textLight.dark',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleTabClick(1)}
                        >
                            <Typography
                                variant="tabLabel"
                                sx={{ borderBottom: activeTab === 1 ? `4px solid ${theme.palette.text.focus}` : 'none' }}
                            >
                                By Sectors
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'inline-block',
                                color: activeTab === 2 ? 'text.focus' : 'textLight.dark',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleTabClick(2)}
                        >
                            <Typography
                                variant="tabLabel"
                                sx={{ borderBottom: activeTab === 2 ? `4px solid ${theme.palette.text.focus}` : 'none' }}
                            >
                                By Technologies
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box
                            sx={{
                                display: 'inline-block',
                                color: activeTab === 3 ? 'text.focus' : 'textLight.dark',
                                cursor: 'pointer'
                            }}
                            onClick={() => handleTabClick(3)}
                        >
                            <Typography
                                variant="tabLabel"
                                sx={{ borderBottom: activeTab === 3 ? `4px solid ${theme.palette.text.focus}` : 'none' }}
                            >
                                Trends
                            </Typography>
                        </Box>
                    </Grid>
                </Stack>

                <Divider sx={{ bgcolor: 'text.focus', mb: 2, mt: 0.5 }} />
            </Box>
            <Box
                bgcolor="backgroundLight.primary"
                sx={() => ({
                    p: { xs: 1, md: 2, lg: 2 }
                })}
            >
                {/* Tab Content */}
                {activeTab === 0 && <HappySignalOverview />}
                {activeTab === 1 && <HappySignalBySector />}
                {activeTab === 2 && <HappySignalByTechnology />}
                {activeTab === 3 && <HappySignalByTrend />}
            </Box>

        </PageWrapper>
    );
};

export default HappySignals;